export const dataTypeMap = {
  string: 'T',
  number: 'N',
  boolean: 'B',
  date: 'D',
  object: 'O',
  array: 'A'
};
